import { render, staticRenderFns } from "./PessoaCargos.vue?vue&type=template&id=29c4f856&"
import script from "./PessoaCargos.vue?vue&type=script&lang=js&"
export * from "./PessoaCargos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports